export const LENGTH_16TH = 16

export const LINE_HEIGHT = 120

export const BARS_BY_LINE = 4

export const TT_BY_LINE = BARS_BY_LINE + ':0' 

export const SECTION_HEADER_HEIGHT = 60

export const LINE_MARGIN_BOTTOM = 16

export const SECTION_MARGIN_BOTTOM = 20

export const TOTAL_LINE_HEIGHT = LINE_HEIGHT + LINE_MARGIN_BOTTOM

export const ROMAN_DEGREES = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']

export const DRAG_TIMEOUT = 120// used to prevent event after dragEnd